import { LitElement, html, css } from './-global.min.js'

export class HHAccordion extends LitElement {
  static properties = {
    button: { state: true },
    content: { state: true },
    slot: { state: true },
  }

  constructor() {
    super()

    this.parent = this.closest(`.${this.dataset.parent}`)
    this.accordions = this.parent?.querySelectorAll('.accordion') || []
  }

  firstUpdated() {
    super.firstUpdated()
    this.maxHeight = this.getAttribute('max-height')
    this.initAccordion()
  }

  initAccordion() {
    this.slot = this.shadowRoot.querySelector('slot')
    for (const child of this.slot.assignedElements()) {
      if (child.tagName === 'BUTTON') {
        this.button = child
      } else {
        this.content = child
      }
    }

    this.initAccordionAction()

    if (this.hasAttribute('open') && this.button && this.content) {
      this.button.classList.add('active')
      this.content.style.maxHeight = this.maxHeight ?? `${this.content.scrollHeight}px`
    }
  }

  initAccordionAction() {
    if (this.button) {
      let slot = null
      this.button.addEventListener('click', (e) => {
        if (this.accordions.length > 1) {
          this.accordions.forEach(accordion => {
            if (accordion === this) return
            slot = accordion.shadowRoot.querySelector('slot')
            for (const child of slot.assignedElements()) {
              if (child.tagName === 'BUTTON') {
                child.classList.remove('active')
              } else {
                child.style.maxHeight = null
              }
            }
          })
        }
        this.button.classList.toggle('active')
        if (this.content.style.maxHeight) {
          this.content.style.maxHeight = null
        } else {
          this.content.style.maxHeight = this.maxHeight ?? `${this.content.scrollHeight}px`
        }
      })
    }
  }

  render() {
    return html`
      <div class="accordion-wrapper">
        <slot></slot>
      </div>
    `
  }
}

customElements.define('hh-accordion', HHAccordion)
